import { Container, Title, Stack, Text } from '@mantine/core';
import { NotificationSettings } from '@/features/settings/components/NotificationSettings';

export function NotificationsPage() {
  return (
    <Container fluid>
      <Stack gap="lg">
        <div>
          <Title order={1}>Notifications</Title>
          <Text c="dimmed" size="sm">
            Configure email notifications for audits, warranties, and maintenance reminders
          </Text>
        </div>

        <NotificationSettings />
      </Stack>
    </Container>
  );
}
